module.exports = {
    Get_All_Event : "PokedexEvent.Get_All_Event",
    Comment_List_Event : "PokedexEvent.Comment_List_Event",
    Comment_Like_Event : "PokedexEvent.Comment_Like_Event",
    Comment_Zan_Event : "PokedexEvent.Comment_Zan_Event",
    Comment_Say_Event : "PokedexEvent.Comment_Say_Event",
    Call_End_Event : "PokedexEvent.Call_End_Event",
    Up_End_Event : "PokedexEvent.Up_End_Event",
}

